import React from 'react';
import { Card } from '@dopomogai/ui';

type Props = {
  pricePerShare: number;
  shares: number;
  total: number;
  remaining: number;
  status: 'draft' | 'active' | 'paused' | 'closed';
};

export function InvestmentSummarySidebar({ pricePerShare, shares, total, remaining, status }: Props) {
  return (
    <Card>
      <div className="p-4 space-y-2">
        <div className="text-sm text-slate-600">Summary</div>
        <div className="flex items-center justify-between"><div>Price / share</div><div className="font-bold">{pricePerShare} cr</div></div>
        <div className="flex items-center justify-between"><div>Shares</div><div className="font-bold">{shares}</div></div>
        <div className="flex items-center justify-between"><div>Total</div><div className="font-extrabold">{total} cr</div></div>
        <div className="flex items-center justify-between text-slate-600"><div>Remaining</div><div>{remaining}</div></div>
        <div className="text-xs text-slate-600">Status: {status}</div>
      </div>
    </Card>
  );
}


